import React, { useRef, useState, useEffect } from "react";
import { Modal, Input, Button, Row, Col } from "antd";
import { InputRef } from "antd/es/input";

interface CalculatorModalProps {
    visible: boolean;
    onClose: () => void;
    onResult?: (value: number) => void;
    getContainer?: () => HTMLElement;
}

const BUTTONS = [
    ["7", "8", "9", "/"],
    ["4", "5", "6", "*"],
    ["1", "2", "3", "-"],
    ["0", ".", "C", "+"],
    ["="],
];

const CalculatorModal: React.FC<CalculatorModalProps> = ({
    visible,
    onClose,
    onResult,
}) => {
    const inputRef = useRef<InputRef>(null);
    const [value, setValue] = useState<string>("");

    // Focus input when modal opens
    useEffect(() => {
        if (visible) setTimeout(() => inputRef.current?.focus(), 150);
    }, [visible]);

    const handleButtonClick = (val: string) => {
        if (val === "C") setValue("");
        else if (val === "=") {
            try {
                const result = eval(value); // You may want to replace eval for security
                setValue(String(result));
                onResult?.(Number(result));
            } catch {
                setValue("Error");
            }
        } else {
            setValue((prev) => prev === "Error" ? val : prev + val);
        }
        setTimeout(() => inputRef.current?.focus(), 0);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            handleButtonClick("=");
            e.preventDefault();
        } else if (e.key === "Escape") {
            onClose();
        } else if (/^[0-9+\-*/.]$/.test(e.key)) {
            handleButtonClick(e.key);
            e.preventDefault();
        } else if (e.key === "Backspace") {
            setValue((prev) => prev.slice(0, -1));
            e.preventDefault();
        }
    };

    return (
        <Modal
            open={visible}
            title="Calculator"
            footer={null}
            onCancel={onClose}
            width={340}
            centered
            styles={{ body: { paddingBottom: 0 } }}
        >
            <Input
                ref={inputRef}
                value={value}
                readOnly
                onKeyDown={handleKeyDown}
                style={{
                    marginBottom: 20,
                    fontSize: 28,
                    textAlign: "right",
                    letterSpacing: 2,
                    border: "2px solid #f0f0f0",
                    borderRadius: 6,
                    background: "#f9f9f9",
                }}
                autoFocus
                spellCheck={false}
                tabIndex={0}
            />
            <div style={{ userSelect: "none" }}>
                {BUTTONS.map((row, i) => (
                    <Row key={i} gutter={8} style={{ marginBottom: 8 }}>
                        {row.map((btn) => (
                            <Col key={btn} span={6}>
                                <Button
                                    style={{
                                        width: "100%",
                                        height: 45,
                                        fontSize: 20,
                                        fontWeight: btn === "=" ? "bold" : "normal",
                                        background: btn === "=" ? "#1677ff" : btn === "C" ? "#ffccc7" : "#fff",
                                        color: btn === "=" ? "#fff" : btn === "C" ? "#ff4d4f" : "#222",
                                        border: btn === "=" ? "none" : undefined,
                                        boxShadow: btn === "=" ? "0 2px 6px #1677ff30" : undefined,
                                    }}
                                    type={btn === "=" ? "primary" : btn === "C" ? "default" : "default"}
                                    danger={btn === "C"}
                                    onClick={() => handleButtonClick(btn)}
                                >
                                    {btn}
                                </Button>
                            </Col>
                        ))}
                    </Row>
                ))}
            </div>
        </Modal>
    );
};

export default CalculatorModal;
